import { useEffect, useRef, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { isApiError, type Out } from "@clubcore/api";
import { useApi } from "../../app/services";
import { useClub } from "../../app/club";
import { useT } from "../../i18n/I18nProvider";
import { Button } from "../../ui/Button";
import { Loading, useErrorMessage } from "../../ui/feedback";
import "./PosMode.css";

export function QrExit({ onApproved }: { onApproved: () => void }) {
  const api=useApi();const {club}=useClub();const t=useT();const describe=useErrorMessage();
  const [request,setRequest]=useState<Out<"pos_create_exit_request">|null>(null);
  const [status,setStatus]=useState('pending');const [error,setError]=useState<unknown>(null);const [generation,setGeneration]=useState(0);
  const approved=useRef(onApproved);
  useEffect(()=>{approved.current=onApproved;},[onApproved]);
  useEffect(()=>{
    let active=true;let id:string|undefined;let timer:number|undefined;let polling=false;
    void api.pos.createExitRequest({terminal_name:`${location.pathname.startsWith('/pos/kitchen')?'Kitchen':'Register'} · ${navigator.platform||'Browser'}`.slice(0,100)}).then((created)=>{
      id=created.id;
      if(!active){void api.pos.cancelExitRequest(id).catch(()=>undefined);return;}
      setRequest(created);
      timer=window.setInterval(()=>{
        if(polling||!active)return;
        polling=true;
        void (async()=>{
          try{
            const result=await api.pos.exitRequestStatus(created.id);
            if(!active)return;
            setStatus(result.status);setError(null);
            if(result.status==='consumed'){
              // A consume response can be lost after the server commits. Recover
              // that acknowledgement from the same session-bound request.
              approved.current();
            }else if(result.status==='approved'){
              const consumed=await api.pos.consumeExitRequest(created.id);
              if(active&&consumed.status==='consumed')approved.current();
            }else if(result.status!=='pending')window.clearInterval(timer);
          }catch(cause){if(active){setError(cause);if(isApiError(cause)&&cause.status===409){setStatus('expired');window.clearInterval(timer);}}}
          finally{polling=false;}
        })();
      },1500);
    }).catch((cause)=>{if(active)setError(cause);});
    return()=>{active=false;window.clearInterval(timer);if(id)void api.pos.cancelExitRequest(id).catch(()=>undefined);};
  },[api,generation]);
  const url=request?`${window.location.origin}/pos-exit-approval?club=${encodeURIComponent(club.slug)}#${request.id}.${request.approval_secret}`:'';
  const waiting=request&&status==='pending';
  return <div className="cc-pos-exit-qr">
    <p>{t('pos.exit.scanHint')}</p>
    {waiting?<><div className="cc-pos-exit-qr__code"><QRCodeSVG value={url} size={224} marginSize={4} level="M" title={t('pos.exit.qrTitle')}/></div>
      <p className="cc-pos-exit-qr__match">{t('pos.exit.matchCode')} <strong>{request.confirmation}</strong></p>
      <p className="cc-muted">{t('pos.exit.expires')}</p><p role="status">{t('pos.exit.waiting')}</p></>:request?<p role="status">{t(status==='denied'?'pos.exit.denied':'pos.exit.expired')}</p>:!error?<Loading/>:null}
    {error?<p className="cc-alert" role="alert">{describe(error)}</p>:null}
    {!waiting&&(request||error)?<Button onClick={()=>{setRequest(null);setError(null);setStatus('pending');setGeneration(n=>n+1);}}>{t('pos.exit.newQr')}</Button>:null}
  </div>;
}
